import type { Service, Testimonial, GalleryItem, StatItem, WhyUsItem, ClientItem } from '@/lib/index';
import { IMAGES } from '@/assets/images';

export const SERVICES: Service[] = [
  {
    id: 'corporate-catering',
    nameAr: 'كيترنج الشركات',
    nameEn: 'Corporate Catering',
    icon: 'briefcase',
    descriptionAr: 'خدمات كيترنج احترافية للشركات والمؤسسات، نوفر حلول ضيافة متكاملة للاجتماعات والفعاليات المؤسسية بأعلى معايير الجودة والالتزام بالمواعيد',
    descriptionEn: 'Professional catering services for companies and institutions, providing complete hospitality solutions for meetings and corporate events with the highest quality standards and punctuality',
    image: IMAGES.CORPORATE_CATERING_7,
  },
  {
    id: 'coffee-break',
    nameAr: 'كوفي بريك الاجتماعات',
    nameEn: 'Coffee Break Meetings',
    icon: 'coffee',
    descriptionAr: 'كوفي بريك فاخر للاجتماعات والمؤتمرات، نقدم تشكيلة متنوعة من المخبوزات الطازجة والحلويات الفاخرة مع القهوة المتخصصة',
    descriptionEn: 'Luxury coffee break for meetings and conferences, offering a diverse selection of fresh pastries and premium desserts with specialty coffee',
    image: IMAGES.COFFEE_POUR_4,
  },
  {
    id: 'daily-bakery',
    nameAr: 'مخبوزات يومية',
    nameEn: 'Daily Baked Goods',
    icon: 'wheat',
    descriptionAr: 'مخبوزات طازجة يومياً من معملنا المتخصص، خبز حرفي وكرواسون ومعجنات بأعلى معايير الجودة والنكهة الأصيلة',
    descriptionEn: 'Fresh daily baked goods from our specialized lab, artisan bread, croissants and pastries with the highest quality standards and authentic flavor',
    image: IMAGES.BREAD_BAKERY_3,
  },
  {
    id: 'cafe-desserts',
    nameAr: 'حلويات للكافيهات',
    nameEn: 'Cafe Desserts Supply',
    icon: 'cake',
    descriptionAr: 'توريد حلويات فاخرة للكافيهات والمطاعم، تشكيلة واسعة من الكيك والتارت والحلويات الفرنسية بجودة ثابتة وتسليم يومي',
    descriptionEn: 'Premium desserts supply for cafes and restaurants, wide selection of cakes, tarts and French pastries with consistent quality and daily delivery',
    image: IMAGES.DESSERTS_5,
  },
  {
    id: 'weddings-events',
    nameAr: 'أعراس ومناسبات',
    nameEn: 'Weddings & Events',
    icon: 'heart',
    descriptionAr: 'كيترنج فاخر للأعراس والمناسبات الخاصة، نصنع تجربة ضيافة لا تُنسى بأطباق مميزة وتقديم راقي يليق بمناسباتكم',
    descriptionEn: 'Luxury catering for weddings and special occasions, creating unforgettable hospitality experiences with distinctive dishes and elegant presentation',
    image: IMAGES.WEDDING_CATERING_1,
  },
  {
    id: 'hospitality-boxes',
    nameAr: 'بوكسات ضيافة',
    nameEn: 'Hospitality Boxes',
    icon: 'gift',
    descriptionAr: 'بوكسات ضيافة فاخرة للهدايا والمناسبات، تغليف أنيق وتشكيلة مختارة من أجود المخبوزات والحلويات',
    descriptionEn: 'Luxury hospitality boxes for gifts and occasions, elegant packaging with a curated selection of the finest baked goods and desserts',
    image: IMAGES.SAVORY_FOOD_4,
  },
];

export const WHY_CHOOSE_US: WhyUsItem[] = [
  {
    id: 'quality',
    titleAr: 'جودة ثابتة',
    descriptionAr: 'نلتزم بأعلى معايير الجودة في كل منتج، من اختيار المواد الخام إلى التسليم النهائي',
    icon: 'award',
    order: 1,
  },
  {
    id: 'speed',
    titleAr: 'سرعة التنفيذ',
    descriptionAr: 'فريق محترف وجاهز لتلبية طلباتكم بسرعة ودقة، مع الالتزام التام بالمواعيد المحددة',
    icon: 'zap',
    order: 2,
  },
  {
    id: 'team',
    titleAr: 'فريق متخصص',
    descriptionAr: 'خبراء في صناعة الضيافة والمخبوزات، مدربون على أعلى المستويات لضمان رضاكم',
    icon: 'users',
    order: 3,
  },
  {
    id: 'capacity',
    titleAr: 'كميات كبيرة',
    descriptionAr: 'معمل متطور بطاقة إنتاجية عالية، قادرون على تلبية احتياجات الشركات والفعاليات الكبرى',
    icon: 'package',
    order: 4,
  },
  {
    id: 'packaging',
    titleAr: 'تغليف فاخر',
    descriptionAr: 'تغليف احترافي وأنيق يعكس قيمة منتجاتنا، مع إمكانية التخصيص بشعار شركتكم',
    icon: 'box',
    order: 5,
  },
  {
    id: 'variety',
    titleAr: 'تنوع في المنتجات',
    descriptionAr: 'مجموعة واسعة من المخبوزات والحلويات والمنتجات الموسمية تلبي جميع الأذواق والمناسبات',
    icon: 'star',
    order: 6,
  },
];

export const TESTIMONIALS: Testimonial[] = [
  {
    id: 'testimonial-1',
    nameAr: 'أحمد المالك',
    companyAr: 'شركة الرياض للاستثمار',
    rating: 5,
    quoteAr: 'خدمة كيترنج احترافية ومتميزة، نتعامل معهم منذ سنتين لجميع اجتماعاتنا وفعالياتنا. الجودة ثابتة والالتزام بالمواعيد ممتاز',
    serviceType: 'corporate',
  },
  {
    id: 'testimonial-2',
    nameAr: 'سارة العتيبي',
    companyAr: 'قاعة الأميرة للأفراح',
    rating: 5,
    quoteAr: 'أطياف الخبازين شريكنا الدائم في جميع حفلات الزواج، الضيوف دائماً يمدحون جودة الطعام والتقديم الراقي. فريق محترف جداً',
    serviceType: 'wedding',
  },
  {
    id: 'testimonial-3',
    nameAr: 'خالد السعيد',
    companyAr: 'كافيه بين الحبوب',
    rating: 5,
    quoteAr: 'نعتمد عليهم في توريد جميع المخبوزات والحلويات لكافيهاتنا الثلاثة، جودة ممتازة وتسليم يومي في الوقت المحدد. شراكة ناجحة',
    serviceType: 'cafe',
  },
];

export const GALLERY_ITEMS: GalleryItem[] = [
  {
    id: 'gallery-1',
    image: IMAGES.DESSERTS_1,
    titleAr: 'حلويات فاخرة',
    category: 'desserts',
  },
  {
    id: 'gallery-2',
    image: '/images/20251012_151808.jpg',
    titleAr: 'حلويات أطياف',
    category: 'desserts',
  },
  {
    id: 'gallery-3',
    image: '/images/98fb4a04-27e8-458f-b28e-2ce2b95d9a70.jpg',
    titleAr: 'طاولة ضيافة',
    category: 'desserts',
  },
  {
    id: 'gallery-4',
    image: IMAGES.WEDDING_CATERING_1,
    titleAr: 'كيترنج الأعراس',
    category: 'wedding',
  },
  {
    id: 'gallery-5',
    image: '/images/WhatsApp Image 2026-05-10 at 12.26.47 AM.jpeg',
    titleAr: 'كيترنج الشركات',
    category: 'corporate',
  },
  {
    id: 'gallery-6',
    image: '/images/كوفي-بريك-7.png',
    titleAr: 'كوفي بريك احترافي',
    category: 'corporate',
  },
  {
    id: 'gallery-7',
    image: '/images/WhatsApp Image 2026-05-05 at 1.31.10 PM (3).jpeg',
    titleAr: 'خبز حرفي',
    category: 'bakery',
  },
  {
    id: 'gallery-8',
    image: '/images/atiyaf_full_collection_1 (1)_page-0001.jpg',
    titleAr: 'الماكرون والشوكولاتة الفاخرة',
    category: 'desserts',
  },
];

export const STATS: StatItem[] = [
  {
    value: '20+',
    labelAr: 'سنة خبرة',
    icon: 'calendar',
  },
  {
    value: '251+',
    labelAr: 'عميل راضٍ',
    icon: 'users',
  },
  {
    value: '2468+',
    labelAr: 'فعالية ناجحة',
    icon: 'trophy',
  },
  {
    value: '50+',
    labelAr: 'منتج يومي',
    icon: 'package',
  },
];

export const CLIENTS: ClientItem[] = [
  {
    id: 'client-1',
    nameAr: 'وزارة المالية',
  },
  {
    id: 'client-2',
    nameAr: 'مركز الملك عبدالله المالي',
  },
  {
    id: 'client-3',
    nameAr: 'هيئة الصحة العامة',
  },
  {
    id: 'client-4',
    nameAr: 'مستشفى الملك فيصل التخصصي',
  },
  {
    id: 'client-5',
    nameAr: 'جامعة الملك سعود',
  },
  {
    id: 'client-6',
    nameAr: 'شركة الاطباق العالمية',
  },
  {
    id: 'client-7',
    nameAr: 'وايت قاردن',
  },
  {
    id: 'client-8',
    nameAr: 'رولاندز كافيه',
  },
];